import { queryOptions } from '@tanstack/react-query';

import { eventsAccessClient } from './client';

export const EVENTS_ACCESS_QUERY_KEYS = {
  eventsAccess: 'gamma-events-access',
};

/** Who may manage their own events: granted populations, and named people. */
export const _getEventsAccess = () =>
  queryOptions({
    queryKey: [EVENTS_ACCESS_QUERY_KEYS.eventsAccess],
    queryFn: () => eventsAccessClient.getEventsAccess(),
  });
